import api from "@/plugins/api";
const PATH = "/opink-consent-matrix";
/**
 * Fetches the current consent matrix configuration from the BFF.
 *
 * The `api` plugin interceptor already unwraps the `ApiResponse<T>` envelope,
 * so `response.data` is the `ConsentMatrix` directly (same pattern as
 * campaigns-api.ts, organisationApi.ts).
 */
export async function getConsentMatrix() {
    const response = await api.get(PATH, { unwrapEnvelope: true });
    return response.data;
}
/**
 * Replaces the consent matrix configuration on the BFF.
 *
 * Returns the updated `ConsentMatrix` as persisted by the backend.
 */
export async function updateConsentMatrix(body) {
    const response = await api.put(PATH, body, { unwrapEnvelope: true });
    return response.data;
}
